var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelNike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 24,
  viewBox: "0 0 60 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FAB14D",
  fillRule: "evenodd",
  d: "M0 17.203c-.014 1.777.496 3.329 1.72 4.505C3.484 23.399 5.426 23.996 7.358 24c2.824.004 5.627-1.262 7.823-2.238C18.877 20.119 59.747.393 59.747.393c.395-.22.32-.493-.173-.356-.199.055-44.493 13.396-44.493 13.396a8.9 8.9 0 0 1-2.578.41c-3.404.022-6.433-2.077-6.409-6.503.01-1.732.487-3.82 1.592-6.276C3.782 6.16.038 12.48 0 17.204"
})));
export default SvgChannelNike;